import React from "react";
import "./about.css"
function About(){
    return(
    <div className="aboutMain" id="about">
        <div className="aboutContainer" >
            <h1 className="aboutHead" >
                About Me
            </h1>
            <br />
            <div className="aboutBody">
            <p>Welcome to my webpage!

                I'm Aymaan Shahzad, a passionate B.Tech student at IITB, hailing from Jabalpur, Madhya Pradesh. Currently, I'm in my second year, specializing in Energy Science and Engineering.

                Beyond academics, my heart beats for creativity and athleticism. <br /> I find solace and joy in producing music, hitting the track for athletics, and spiking it on the volleyball court.

                <br />Tech is my playground, and I love exploring new avenues. As a React Frontend Developer, I'm deeply involved in crafting engaging and dynamic web applications. I'm also delving into the world of Data Science using Python to analyze and derive insights from data.

                <br />When I'm not immersed in coding or studies, you can catch me with my nose buried in books. Fiction takes me on thrilling adventures, providing the perfect escape from reality.

                <br />Currently, I'm proudly serving as the Associate Secretary in my department for the tenure 2023-24, nurturing my leadership, communication, and organizational skills. 

                This webpage is a space where I share my journey, insights, and creations. Let's connect and explore the possibilities together! 

                Join me on this exciting ride as we embrace technology, energy, creativity, and everything in between.</p>
            </div>
        </div>
    </div>
    )
}

export default About;
